"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var FetchUtils = /*#__PURE__*/function () {
  function FetchUtils() {
    _classCallCheck(this, FetchUtils);
  }

  _createClass(FetchUtils, null, [{
    key: "checkStatus",
    value: function checkStatus(res) {
      if (res.ok) {
        return res.json().then(function (body) {
          var status = _lodash.default.get(body, 'error.status');

          if (status && status > 200) {
            return Promise.reject(body);
          }

          return body;
        });
      } else {
        return res.json().catch(function () {
          if (res.status === 403 && res.statusText === 'Forbidden') return Promise.reject(new Error('Rejected by WAF'));
        }).then(function (err) {
          return Promise.reject(err);
        });
      }
    }
  }]);

  return FetchUtils;
}();

var _default = FetchUtils;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/fetchUtils.js
// module id = 6
// module chunks = 0